/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { ScaleTransform } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { AnimationKeyFrameEffect } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { LinkedList$1 } from "igniteui-react-core";
import { IKeyFrameAnimation_$type } from "igniteui-react-core";
import { AnimationKeyFrameProperty } from "igniteui-react-core";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var RippleView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RippleView, _super);
    function RippleView() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.g = null;
        _this.c = null;
        _this.f = new List$1(Delegate_$type, 0);
        _this.l = null;
        _this.d = true;
        _this.k = null;
        _this.h = null;
        _this.j = null;
        _this.i = null;
        return _this;
    }
    RippleView.prototype.w = function () {
    };
    RippleView.prototype.e = function () {
        return true;
    };
    RippleView.prototype.t = function (a) {
        var e_1, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.f.clear();
        }
        this.g = a;
        this.b.af();
    };
    RippleView.prototype.v = function () {
        var e_2, _a;
        if (this.b.p == null) {
            this.l = null;
            try {
                for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var a = _c.value;
                    a();
                }
            }
            catch (e_2_1) {
                e_2 = { error: e_2_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_2)
                        throw e_2.error;
                }
            }
            this.f.clear();
        }
        else {
            var b = this.b.p;
            var c = this.g.getWrapper(b);
            this.l = c;
            this.f.add(c.listen("click", runOn(this, this.p)));
            this.f.add(c.listen("mouseenter", runOn(this, this.q)));
            this.f.add(c.listen("mouseleave", runOn(this, this.r)));
        }
    };
    RippleView.prototype.r = function (a) {
        this.b.ad();
    };
    RippleView.prototype.q = function (a) {
        this.b.ac();
    };
    RippleView.prototype.p = function (a) {
        if (this.l == null) {
            return;
        }
        var b = this.g.rootWrapper.getOffset();
        var c = a.pageX - b.left;
        var d = a.pageY - b.top;
        this.b.ai(c, d, this.g.rootWrapper.outerWidth(), this.g.rootWrapper.outerHeight());
    };
    RippleView.prototype.aa = function () {
        if (this.b.i) {
            this.g.rootWrapper.setStyleProperty("background-color", this.b.ap._fill);
        }
    };
    RippleView.prototype.x = function () {
        this.g.rootWrapper.setStyleProperty("background-color", "transparent");
    };
    RippleView.prototype.z = function () {
        this.g.rootWrapper.setStyleProperty("background-color", this.b.ap._fill);
    };
    RippleView.prototype.m = function (a, b, c) {
        var d = this.g.createElement("span");
        d.setStyleProperty("width", c * 2 + "px");
        d.setStyleProperty("height", c * 2 + "px");
        d.setStyleProperty("top", b + "px");
        d.setStyleProperty("left", a + "px");
        d.setStyleProperty("background-color", this.b.aq._fill);
        d.setStyleProperty("position", "absolute");
        d.setStyleProperty("pointer-events", "none");
        d.setStyleProperty("border-radius", c + "px");
        d.setStyleProperty("opacity", ".5");
        NativeUI.z(d, ((function () {
            var $ret = new ScaleTransform();
            $ret.l = 0.3;
            $ret.m = 0.3;
            return $ret;
        })()));
        this.g.append(d);
        return d;
    };
    RippleView.prototype.y = function (a) {
        var b = a;
        b.remove();
    };
    RippleView.prototype.n = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.g;
        }
    };
    RippleView.prototype.a = function (a, b) {
        return new AnimationKeyFrameEffect(0, a, 0, null, b);
    };
    RippleView.prototype.o = function (a) {
    };
    RippleView.prototype.s = function () {
        this.d = true;
        this.v();
    };
    RippleView.prototype.u = function () {
        var e_3, _a;
        this.d = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
        this.f.clear();
    };
    RippleView.$t = markType(RippleView, 'RippleView');
    return RippleView;
}(Base));
export { RippleView };
/**
 * @hidden
 */
var Ripple = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Ripple, _super);
    function Ripple() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.i = false;
        _this.o = null;
        _this.ao = null;
        _this.an = null;
        _this.al = Ripple.ar;
        _this.l = new LinkedList$1(IKeyFrameAnimation_$type);
        _this.am = Ripple.as;
        _this.m = 600;
        _this.e = false;
        _this.d = false;
        _this.f = false;
        _this.propertyChanged = null;
        var a = new RippleView();
        a.b = _this;
        _this.b = a;
        _this.b.w();
        return _this;
    }
    Ripple.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Ripple.prototype.ae = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.ag(a, b, c);
    };
    Ripple.prototype.ag = function (a, b, c) {
        switch (a) {
            case "RippleColor":
                this.aq = this.au != null ? this.au : Ripple.as;
                break;
            case "HoverColor":
                this.ap = this.at != null ? this.at : Ripple.ar;
                break;
            case "EventSource":
                if (this.b.e()) {
                    this.b.v();
                }
                break;
            case "ActualRippleColor":
                this.ak();
                break;
            case "ActualHoverColor":
                this.aj();
                break;
        }
    };
    Ripple.prototype.aj = function () {
        if (this.h) {
            this.b.x();
            return;
        }
        this.b.aa();
    };
    Ripple.prototype.ak = function () {
    };
    Ripple.prototype.ac = function () {
        this.i = true;
        if (this.h) {
            this.b.x();
            return;
        }
        if (this.j) {
            this.b.z();
        }
    };
    Ripple.prototype.ad = function () {
        this.i = false;
        if (this.j || this.h) {
            this.b.x();
        }
    };
    Object.defineProperty(Ripple.prototype, "p", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            if (b != this.o) {
                this.ae("EventSource", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "au", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (b != this.ao) {
                this.ae("RippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "at", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (b != this.an) {
                this.ae("HoverColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "ap", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (b != this.al) {
                this.ae("ActualHoverColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Ripple.prototype.ai = function (a, b, c, d) {
        var _this = this;
        if (this.h) {
            return;
        }
        var e = Math.max(c, d);
        var f = e / 2;
        var g = a - f;
        var h = b - f;
        if (this.g) {
            g = 0;
            h = 0;
        }
        var i = this.b.m(g, h, f);
        var j = this.c(i);
        this.l.f(j);
        var k = this.l.d;
        j.play();
        j.finished.f(function (l) {
            j.commitStyles();
            _this.l.h(k);
            _this.b.y(i);
        });
    };
    Ripple.prototype.c = function (a) {
        var b = this.a;
        var c = KeyFrameAnimationFactory.f.c(this.b.a(a, b).m(new AnimationKeyFrameProperty(1, 0.5), new AnimationKeyFrameProperty(14, ((function () {
            var $ret = new ScaleTransform();
            $ret.l = 0.3;
            $ret.m = 0.3;
            return $ret;
        })()))).m(new AnimationKeyFrameProperty(1, 0), new AnimationKeyFrameProperty(14, ((function () {
            var $ret = new ScaleTransform();
            $ret.l = 2;
            $ret.m = 2;
            return $ret;
        })()))));
        return c;
    };
    Object.defineProperty(Ripple.prototype, "aq", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.ae("ActualRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "n", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.ae("RippleDuration", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "h", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.ae("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "g", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            var b = this.d;
            this.d = a;
            if (b != this.d) {
                this.ae("IsCentered", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Ripple.prototype, "j", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.ae("IsHoverEnabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Ripple.prototype.af = function () {
        this.b.v();
    };
    Object.defineProperty(Ripple.prototype, "a", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = this.n;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    Ripple.prototype.onDetachedFromUI = function () {
        this.b.u();
    };
    Ripple.prototype.onAttachedToUI = function () {
        this.b.s();
    };
    Ripple.prototype.k = function () {
        return this.b.e();
    };
    Ripple.prototype.provideContainer = function (a) {
        this.b.t(a);
    };
    Ripple.$t = markType(Ripple, 'Ripple', Base.$, [INotifyPropertyChanged_$type]);
    Ripple.ar = BrushUtil.g(40, 0, 0, 0);
    Ripple.as = BrushUtil.g(189, 0, 0, 0);
    return Ripple;
}(Base));
export { Ripple };
//# sourceMappingURL=RippleView_combined.js.map
